import RFIDInstance from './RFID';
// import RFBluetoothInstance from './RFBluetooth';
import { runPromiseByQueue } from '../js/utils';
import Toast from '../components/toast/Toast';
import { stepStore } from '../mobx/stores/step';

export default class ProcessInfo {
  stop = false;

  start() {
    if (this.stop) return false;
    const {
      // readSerialNo,
      // auth,
      readGeoWorkMode,
      // readProjectParam,
      readIMEI,
      readIMSI,
      readICCID,
      readMode
    } = RFIDInstance;
    // const { connectBluetooth } = RFBluetoothInstance;

    return runPromiseByQueue([
      // readSerialNo.bind(RFIDInstance),
      // auth.bind(RFIDInstance),
      readGeoWorkMode.bind(RFIDInstance),
      // readProjectParam.bind(RFIDInstance)
    ]).then(({ skip }) => {
      const queue = [
        readIMEI.bind(RFIDInstance),
        readIMSI.bind(RFIDInstance),
        readICCID.bind(RFIDInstance),
        readMode.bind(RFIDInstance)
      ];

      return runPromiseByQueue(queue).then(() => {
        // eslint-disable-next-line no-unused-expressions
        this.stop = true;
        stepStore.allLoad = true;
      }).catch(error => Toast.fail(error));
    }).catch(error => Toast.fail(error));
  }

  stopNext() {
    this.stop = true;
  }
}
